import React, { FC, forwardRef } from 'react';
import { InputNumber } from 'antd';
import cx from 'classnames';
import { isNil, isString } from 'lodash';
import { InputNumberProps } from 'antd/lib/input-number';
import { setNumberWithComma } from '../../../lib/common';
import './InputNumber.scss';

export interface CustomInputNumberProps extends Omit<InputNumberProps, 'onChange'> {
  onChange?: (value: number | undefined) => void;
  addonAfter?: string | React.ReactNode;
  isEditable?: boolean;
  unit?: string;
}

const CustomInputNumber: FC<CustomInputNumberProps> = forwardRef<HTMLInputElement, CustomInputNumberProps>(
  (props, ref) => {
    const {
      className,
      onChange,
      addonAfter,
      value,
      isEditable = true,
      precision = 0,
      unit = '원',
      size = 'large',
      ...res
    } = props;

    return (
      <>
        {isEditable ? (
          <InputNumber
            className={cx('amondz-input-number', className)}
            onChange={(value) => onChange && onChange(typeof value === 'number' ? value : undefined)}
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => (!isNil(value) ? value.replace(/,*/g, '') : '')}
            precision={precision}
            value={value}
            size={size}
            ref={ref}
            {...res}
          />
        ) : (
          <div>{setNumberWithComma(value, unit)}</div>
        )}
        {addonAfter && isEditable ? (
          isString(addonAfter) ? (
            <div className="addon-after">{addonAfter}</div>
          ) : (
            addonAfter
          )
        ) : null}
      </>
    );
  },
);

CustomInputNumber.displayName = 'CustomInputNumber';

export default CustomInputNumber;
